import React, { FC } from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import useCommonStyles from 'styles/common';
import CenterImage from 'components/common/CenterImage';
import CommonButton from 'components/common/CommonButton';

import voteTitleImg from 'assets/vote/vote-title.svg';
import cookbookTitleImg from 'assets/vote/cookbook-title.svg';
import cookbookTitleMobileImg from 'assets/vote/cookbook-title-mobile.svg';
import menuRedImg from 'assets/vote/menu-red.png';
import menuWhiteImg from 'assets/vote/menu-white.png';
import guideTitleImg from 'assets/vote/guideline-title.svg';
import awardTitleImg from 'assets/vote/vote-award-title.svg';
import award01 from 'assets/vote/award01.png';
import award02 from 'assets/vote/award02.png';

import { Tomato02, Tomato03, Milk01, Milk02, Cauli, Milk03 } from 'components/home/stamps';

const useStyles = makeStyles((theme) => ({
	voteSection: { 
		color: 'var(--color-tertiary)',
	},
	cookbookContainer: {
		padding: '0 20px',
		display: 'flex',
		position: 'relative',
		justifyContent: 'center',
        [theme.breakpoints.down('xs')]: {
			padding: '0 8px',
			flexDirection: 'column'
		}
	},
	cookbookTitleOverlay: {
		position: 'absolute',
		width: 500,
		right: 'calc(50% - 250px)',
        [theme.breakpoints.down('xs')]: {
			right: 12,
			top: 0,
			width: 'calc(100% - 24px)'
		},

        '& div:nth-of-type(1)': {
            marginTop: 39,
			[theme.breakpoints.down('xs')]: {
            	marginTop: 14,
			}
        },
        '& div:nth-of-type(2)': {
            marginTop: 24,
        },
        '& div:nth-of-type(3)': {
            marginTop: 36,
			width: 240
        },
	},
	cookbook: {
		flex: 1,
		borderRadius: 16,
		maxWidth: 696,
		padding: '273px 10px 52px 10px',
        [theme.breakpoints.down('xs')]: {
    		borderRadius: 8
		}
	},
	cookbookLeft: {
		backgroundColor: 'var(--color-primary)',
        [theme.breakpoints.down('xs')]: {
    		padding: '314px 30px 35px 30px'
		}
	},
	cookbookRight: {
		backgroundColor: 'var(--color-secondary)',
        [theme.breakpoints.down('xs')]: {
    		padding: '38px 30px 35px 30px'
		}
	},
	
	guidelinesContainer: {
		maxWidth: 1200,
		marginTop: 52,
		padding: '0 60px',
        [theme.breakpoints.down('xs')]: {
			marginTop: 37,
			padding: '0 28px',
		}
	},
	guidelinesTopContent: {
		position: 'relative',
		'& h6:nth-of-type(1)' : {
			marginTop: 36,
		},
		[theme.breakpoints.down('xs')]: {
			'& h6' : {
				fontSize: 16,
				'&:nth-of-type(1)': {
					marginTop: 24,
				}
			},
		}
	},
	guidelinesTopContentTitle: {
		maxWidth: 192,
		[theme.breakpoints.down('xs')]: {
			maxWidth: 160
		}
	},

	guidelinesSecondContent: {
		position: 'relative',
		textAlign: 'left'
	},

	awards: {
		marginTop: 36,
		position: 'relative',
        [theme.breakpoints.down('xs')]: {
			padding: '0 28px'
		}
	},
    cardsContainer: {
		maxWidth: 582,
		display: 'flex',
		flexWrap: 'nowrap',
		gap: 16,
        [theme.breakpoints.down('xs')]: {
			flexDirection: 'column'
		}
    },

    cardContent: {
		flex: '1 1 150px',
        position: 'relative',
    },

    awardCard: {
		width: '100%',
		justifyContent: 'space-evenly',
		boxSizing: 'border-box',
		backgroundColor: 'var(--color-white)',
		aspectRatio: '1/1',
		border: '1px solid var(--color-tertiary)',
		borderRadius: 16,
        textAlign: 'center',
		marginBottom: 16,
        [theme.breakpoints.down('xs')]: {
			maxWidth: 180,
			'& img': {
				maxWidth: 148
			}
		}
    }
}));


const VoteSection: FC = () => {
	const classes = useStyles();
	const common = useCommonStyles();

	return (<div className={ cx(common.columnCenter, common.fullWidth, classes.voteSection) }>
		<div className={ cx(common.fullWidth, classes.cookbookContainer) }>
			<div className={ cx(classes.cookbookTitleOverlay, common.columnCenter, common.fullWidth) }>
				<CenterImage src={voteTitleImg} alt='vote-title'/>
				<CenterImage src={cookbookTitleImg} alt='cookbook-title' className={ common.hideInMobile }/>
				<CenterImage src={cookbookTitleMobileImg} alt='cookbook-title' className={ common.displayInMobile }/>
			</div>
			<div className={ cx(classes.cookbook, classes.cookbookLeft, common.columnCenter) }>
				<CenterImage 
					src={menuRedImg} alt='red-menu'
					maxWidth={630} className={common.fullWidth}
				/>
				<Typography 
					className={ common.hideInMobile }
					variant="subtitle1"
					style={{ marginTop: 16, color: 'var(--color-white'}}
				>{`濃香拿坡里義大利麵`}</Typography>
				
				<CommonButton
					buttonText="更多蕃茄紅醬食譜"
					style={{ marginTop: 24 }}
					onClick={() => {
						const url = "https://www.housefoods.com.tw/recipe/ccat_homeuse,japanese,hayashi.html"
						window.open(url, "_blank", "noopener,noreferrer")
					}}
				/>

			</div>
			<div className={ cx(classes.cookbook, classes.cookbookRight, common.columnCenter) }>
				<CenterImage 
					src={menuWhiteImg} alt='red-menu'
					maxWidth={630} className={common.fullWidth}
				/>
				<Typography 
					className={ common.hideInMobile }
					variant="subtitle1"
					style={{ marginTop: 16}}
				>{`和風奶油義大利麵`}</Typography>
				<CommonButton
					buttonText="更多北海道白醬食譜"
					style={{ marginTop: 24 }}
					onClick={() => {
						const url = "https://www.housefoods.com.tw/recipe/ccat_homeuse,japanese,stew.html"
						window.open(url, "_blank", "noopener,noreferrer")
					}}
				/>
			</div>
		</div>

		<div className={ cx(common.fullWidth, classes.guidelinesContainer, common.columnCenter) }>
			<div className={cx(classes.guidelinesTopContent, common.columnCenter)}>
				<Milk01 style={{ top: 10, left: -310, width: 65, transform: 'rotate(-12deg)'}} />
				<Cauli style={{ top: 110, right: -345}} />
				
				<Cauli className={common.displayInMobile} style={{ top: -25, right: -22, width: 38 }} />
				<Milk01 className={common.displayInMobile} style={{ top: 37, left: -18, width: 36, transform: 'rotate(-12deg)'}} />
				<Tomato02 className={common.displayInMobile} style={{ top: 240, left: -17, width: 24 }} />

				<CenterImage src={guideTitleImg} alt='guide-title' className={classes.guidelinesTopContentTitle}/>
				<Typography
					variant="subtitle1"
					style={{ whiteSpace: 'pre-line' }}
				>
					{`好侍食品旗下來自日本的雙醬洋食
					滿滿完熟蕃茄精華濃縮的「蕃茄紅醬」
					vs. 
					嚴選北海道 100% 鮮奶製成的「北海道白醬」
					到底誰可稱霸 2025 紅白洋食人氣王？`}
				</Typography>

				<Typography
					variant="subtitle1"
					style={{ whiteSpace: 'pre-line', color: 'var(--color-red)' }}
				>
					{`
					一起來投票，應援您最愛的洋食料理 !
					投票就可抽獎，天天應援中獎機會更高 !`}
				</Typography>
			</div>
			
			<div className={ classes.guidelinesSecondContent }>
				<Tomato02 style={{ top: 150, left: -110}} />
				<Milk02 style={{ top: 372, right: -110}} />

				<Typography 
					variant="subtitle1" style={{ marginTop: 36}}
				>{`活動期間`}</Typography>
				<ul>
					<li>
						<Typography variant='body1'>
							{`投票應援時間：2025年6月6日至7月3日`}
						</Typography>
					</li>
				</ul>
				<Typography
					variant="body2"
					style={{ whiteSpace: 'pre-line' }}
				>
					{`* 時間判別以本活動網站系統為準
					* 得獎公布日期：預計2025年7月14日(一)當天公布`}
				</Typography>

				<Typography variant="subtitle1" style={{ marginTop: 24 }}>{`活動辦法`}</Typography>
				<ul>
					<li>
						<Typography variant='body1'>
							{`投票方式：活動期間內，每日於此活動網站選擇「蕃茄燴飯」或「北海道白醬」應援投票 (二選一)，並填寫基本資料，即可獲得抽獎資格!`}
						</Typography>
					</li>
				</ul>
				<Typography
					variant="body2"
					style={{ whiteSpace: 'pre-line' }}
				>
					{`* 完成基本資料填寫後進行投票，每人每日限投一票，可天天投票應援，完成投票次數越多，中獎機會越高，記得每天都來投票哦！ 
					　(每人最多限得一個獎品)。
					* 每次需登入有效e-mail進行投票，填寫資訊作為得獎通知之聯絡方式。將以e-mail要求得獎者回信。不可使用不同e-mail重覆投票。
					* 參加本活動者如未滿18歲(西元2007年6月5日以後出生)或未正確填寫資料，主辦單位將取消其參加及兌獎資格。
					* 個人資料僅限台灣好侍食品「2025 Masaの紅白洋食對決」發票登錄及線上投票活動使用。`}
				</Typography>	
			</div>
		</div>

		<div className={ cx(common.fullWidth, common.columnCenter, classes.awards )}>
			<Tomato03 style={{ bottom: 232, right: 'calc(50vw - 663px)', width: 55}} />

			<Milk03 className={common.displayInMobile} style={{ top: 80, right: 15, width: 34 }} />
			<Milk02 className={common.displayInMobile} style={{ top: 300, left: 11, width: 40 }} />
			<Tomato03 className={common.displayInMobile} style={{ top: 545, right: 15, width: 26}} />

			<CenterImage src={awardTitleImg} alt='award-title' maxWidth={384}/>
			<div className={ cx(classes.cardsContainer, common.fullWidth) } style={{ marginTop: 36 }}>
				<div className={ cx(common.columnCenter, classes.cardContent) }>
					<div className={ cx(classes.awardCard, common.columnCenter) }>
						<Typography variant="body1">{'優勝獎勵抽'}</Typography>
						<CenterImage src={award01} alt='award-01'/>
					</div>
					<Typography variant="body1" style={{ whiteSpace: 'pre-line' }} >
						{`全聯禮券$1,000
						+
						紅白洋食料理塊
						共10名`}
					</Typography>
					
				</div>				
				<div className={ cx(common.columnCenter, classes.cardContent) }>
					<div className={ cx(classes.awardCard, common.columnCenter) }>
						<Typography variant="body1">{'敗部加碼抽'}</Typography>
						<CenterImage src={award02} alt='award-02'/>
					</div>
					<Typography variant="body1" style={{ whiteSpace: 'pre-line' }} >
						{`全聯禮券$500
						+
						紅白洋食料理塊
						共10名`}
					</Typography>
					
				</div>		
			</div>
		</div>
	</div>);
};

export default VoteSection;
